var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.4001 7.1999C7.72558 7.1999 8.8001 6.12539 8.8001 4.7999C8.8001 3.47442 7.72558 2.3999 6.4001 2.3999C5.07461 2.3999 4.0001 3.47442 4.0001 4.7999C4.0001 6.12539 5.07461 7.1999 6.4001 7.1999Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.4001 8.7999C9.05106 8.7999 11.2001 10.9489 11.2001 13.5999H1.6001C1.6001 10.9489 3.74913 8.7999 6.4001 8.7999Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8001 5.5999C12.8001 5.15807 12.4419 4.7999 12.0001 4.7999C11.5583 4.7999 11.2001 5.15807 11.2001 5.5999V6.3999H10.4001C9.95827 6.3999 9.6001 6.75807 9.6001 7.1999C9.6001 7.64173 9.95827 7.9999 10.4001 7.9999H11.2001V8.7999C11.2001 9.24173 11.5583 9.5999 12.0001 9.5999C12.4419 9.5999 12.8001 9.24173 12.8001 8.7999V7.9999H13.6001C14.0419 7.9999 14.4001 7.64173 14.4001 7.1999C14.4001 6.75807 14.0419 6.3999 13.6001 6.3999H12.8001V5.5999Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.4001 7.1999C7.72558 7.1999 8.8001 6.12539 8.8001 4.7999C8.8001 3.47442 7.72558 2.3999 6.4001 2.3999C5.07461 2.3999 4.0001 3.47442 4.0001 4.7999C4.0001 6.12539 5.07461 7.1999 6.4001 7.1999Z",
    stroke: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.4001 8.7999C9.05106 8.7999 11.2001 10.9489 11.2001 13.5999H1.6001C1.6001 10.9489 3.74913 8.7999 6.4001 8.7999Z",
    stroke: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8001 5.5999C12.8001 5.15807 12.4419 4.7999 12.0001 4.7999C11.5583 4.7999 11.2001 5.15807 11.2001 5.5999V6.3999H10.4001C9.95827 6.3999 9.6001 6.75807 9.6001 7.1999C9.6001 7.64173 9.95827 7.9999 10.4001 7.9999H11.2001V8.7999C11.2001 9.24173 11.5583 9.5999 12.0001 9.5999C12.4419 9.5999 12.8001 9.24173 12.8001 8.7999V7.9999H13.6001C14.0419 7.9999 14.4001 7.64173 14.4001 7.1999C14.4001 6.75807 14.0419 6.3999 13.6001 6.3999H12.8001V5.5999Z",
    stroke: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddUser);
export default __webpack_public_path__ + "static/media/add-user.5ce54f5cb472a3269c1bf4e535b81f46.svg";
export { ForwardRef as ReactComponent };